import { MutateOptions, UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  RemoveBuyersFromListInput,
  RemoveBuyersFromListMutation,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const removeBuyersFromListMutation = graphql(`
  mutation removeBuyersFromList($input: RemoveBuyersFromListInput!) {
    removeBuyersFromList(input: $input) {
      id
      name
    }
  }
`);

export function useRemoveBuyerEntries(
  options?: UseMutationOptions<
    RemoveBuyersFromListMutation,
    unknown,
    RemoveBuyersFromListInput,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(removeBuyersFromListMutation, {
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      void queryClient.invalidateQueries(["searchOrganisationsViaOs"]);
      void queryClient.invalidateQueries(["supplierStatsOrganisation"]);
      void queryClient.invalidateQueries(["buyers", "buyersForSupplier"]);
      options?.onSuccess?.(data, variables.input, context);
    },
  });
  return {
    ...rest,
    mutate: (
      input: RemoveBuyersFromListInput,
      callOptions?: MutateOptions<
        RemoveBuyersFromListMutation,
        unknown,
        { input: RemoveBuyersFromListInput },
        unknown
      >,
    ) => innerMutate({ input }, callOptions),
  };
}
